import { useSyncExternalStore } from 'react';

import { type Toast, type ToastHub, toastHub as defaultHub } from './toastHub';

/**
 * The React binding over `toastHub` — docs/ARCHITECTURE.md §6.
 *
 * `useSyncExternalStore` rather than a context + `useState` pair, for the same reason the
 * document store uses it: the hub is the source of truth and React is a subscriber, so there
 * is no second copy of the toast list to fall out of step, and a toast raised from outside a
 * component tree (a command handler, a rejected clipboard promise) still lands.
 *
 * The third argument is the server snapshot. This app never renders on a server, but React
 * calls it during hydration checks in some paths, and handing it the same cached array keeps
 * it from tearing.
 */
export function useToasts(hub: ToastHub = defaultHub): readonly Toast[] {
  return useSyncExternalStore(hub.subscribe, hub.getSnapshot, hub.getSnapshot);
}

export default useToasts;
